import BaseEvent from './BaseEvent.js';
import { getOSM } from '../../OverworldAnimation.js';

export default class DontForgetLunchbox extends BaseEvent {
    constructor({
        identifier = 'dont_forget_lunchbox',
        isActive = false,
        complete = false,
        autoComplete = false,
        objectsIdentifiers = [],
    } = {}) {
        super({ identifier, isActive, complete, autoComplete, objectsIdentifiers });
    }

    static deserialize(data) {
        return new DontForgetLunchbox({
            isActive: data.isActive,
            complete: data.complete,
        });
    }

    preComplete() {
        const osm = getOSM();
        const player = osm.player;

        if (player.items.keyItems.lunchbox.length > 0) {
            this.complete = true;
            return;
        }
    }

    executeActions() {
        const osm = getOSM();
        const player = osm.player;

        if (player.items.keyItems.lunchbox.length > 0) {
            this.complete = true;
            return;
        }

        osm.readText(`We should get Professor Abu’s Lunch Box before we head back to the lab...`);
        osm.finishReading();
        osm.script(() => {
            player.ignoreEventStepCount = 1;
        });
        osm.movePlayer([{ right: 2 }]);
    }
}
